<template>
  <div>
    <Search :searchForm="searchForm" title="" />
    <!-- <Table></Table> -->
    <!-- <UserTree></UserTree> -->
  </div>
</template>
<script>
import UserTree from "@/components/search/UserTree.vue";
import Search from "@/components/search/Search.vue";
import Table from "@/components/table.vue";
import { CRM_USER_TREE } from "@/util/keys";
import { agentAccountConfig } from "../../../../components/search/templateConfig.js";
export default {
  data() {
    return {
      searchForm: agentAccountConfig,
      titleData: [
        {
          key: 1,
          fixed: true,
          prop: "date",
          labelKey: "date",
          width: "150",
          emptyText: false
        },
        {
          key: 2,
          fixed: false,
          prop: "name",
          labelKey: 'textzuxc',
          width: "120",
          emptyText: false
        },
        {
          key: 3,
          fixed: false,
          prop: "province",
          labelKey: 'textt7uv',
          width: "120",
          emptyText: false
        },
        {
          key: 4,
          fixed: false,
          prop: "city",
          labelKey: 'textkxzs',
          width: "120",
          emptyText: false
        },
        {
          key: 5,
          fixed: false,
          prop: "address",
          labelKey: 'address',
          width: "120",
          emptyText: false
        },
        {
          key: 6,
          fixed: false,
          prop: "zip",
          labelKey: 'text7633',
          width: "120",
          emptyText: false
        }
      ],
      tableData: [
        {
          date: "2016-05-02",
          name: this.$t('financeCenter.auto_52_d17a4725'),
          province: this.$t('financeCenter.auto_53_28a9915d'),
          city: this.$t('financeCenter.auto_54_d648a147'),
          address: this.$t('financeCenter.auto_55_5f6611f6'),
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: this.$t('financeCenter.auto_56_3ee2dbc5'),
          province: this.$t('financeCenter.auto_57_2451d523'),
          city: this.$t('financeCenter.auto_58_ca225558'),
          address: this.$t('financeCenter.auto_59_2d6a5ca7'),
          zip: 200333
        },
        {
          date: "2016-05-01",
          name: this.$t('financeCenter.auto_60_898bbf9d'),
          province: this.$t('financeCenter.auto_61_97f5b154'),
          city: this.$t('financeCenter.auto_62_56cec1b0'),
          address: this.$t('financeCenter.auto_63_f7968f67'),
          zip: 200333
        },
        {
          date: "2016-05-03",
          name: this.$t('financeCenter.auto_64_f6b2ed60'),
          province: this.$t('financeCenter.auto_65_3de41d78'),
          city: this.$t('financeCenter.auto_66_7c5347c4'),
          address: this.$t('financeCenter.auto_67_6b0e8395'),
          zip: 200333
        }
      ]
    };
  },
  methods: {
    async getUser() {
      let UserTree = JSON.parse(sessionStorage.getItem(CRM_USER_TREE) || "[]");
      if (UserTree <= 0) {
        UserTree = await getUserTree();
        UserTree = UserTree.code === 0 ? UserTree.data : [];
        sessionStorage.setItem(CRM_USER_TREE, JSON.stringify(UserTree));
      }
      this.setState({ UserTree });
      console.log("UserTree", UserTree);
    }
  },
  components: {
    Search,
    UserTree,
    Table
  },
  mounted() {}
};
</script>
./templateConfig.js
